import AttendeeVisibilityForm from './AttendeeVisibilityForm';
import { connect } from 'react-redux';
import _ from 'lodash';

export function mapStateToProps (state) {
  const { booking, auth } = state;
  const bookingId = _.get(booking, 'booking._id');
  const isPatching = _.get(booking, 'isPatching');
  const accessToken = _.get(auth, 'accessToken');

  return {
    bookingId,
    accessToken,
    isPatching,
    initialValues: {
      shareState: _.get(booking, 'booking.share_state')
    }
  };
}

const AttendeeVisibilityFormC = connect(mapStateToProps)(AttendeeVisibilityForm);

export default AttendeeVisibilityFormC;
